/**
 * PartOneSlides.tsx
 * -----------------
 * Learning slides for crash course part one.
 * - Multilingual content and video.
 * - Updates progress and points on completion.
 */


import React from 'react';
import { useProgress } from '../../../context/ProgressContext';
import Button from '../../common/Button';
import { useHistory } from 'react-router-dom';
import Box from '../../common/Box';

const t = {
  slide1_title: {
    fi: 'Johdanto',
    en: 'Introduction',
    sv: 'Introduktion',
  },
  slide1_content: {
    fi: 'Tervetuloa turvallisuuskurssille! Tässä osiossa opit saunan ja muiden kodinkoneiden turvallisesta käytöstä suomalaisissa olosuhteissa.',
    en: "Welcome to the safety course! In this section, you'll learn how to safely use saunas and household appliances in Finnish conditions.",
    sv: 'Välkommen till säkerhetskursen! I det här avsnittet lär du dig att använda bastu och hushållsapparater säkert i finländska förhållanden.',
  },
  slide2_title: {
    fi: 'Miksi turvallisuus on tärkeää?',
    en: 'Why is safety important?',
    sv: 'Varför är säkerhet viktigt?',
  },
  slide2_content: {
    fi: 'Saunojen ja sähkölaitteiden väärä käyttö voi aiheuttaa tulipaloja tai muita vaaratilanteita.',
    en: 'Improper use of saunas and electrical appliances can cause fires or other hazardous situations.',
    sv: 'Felaktig användning av bastur och elapparater kan orsaka bränder eller andra farliga situationer.',
  },
  slide3_title: {
    fi: 'Tavoitteet',
    en: 'Goals',
    sv: 'Mål',
  },
  slide3_content: {
    fi: 'Tavoitteena on oppia turvalliset käytännöt suomalaisiin oloihin soveltuvien laitteiden käyttöön.',
    en: 'The goal is to learn safe practices for using appliances adapted to Finnish conditions.',
    sv: 'Målet är att lära sig säkra rutiner för användning av apparater i finländska förhållanden.',
  },
  video_title: {
    fi: 'Katso: Johdanto turvallisuuteen',
    en: 'Watch: Introduction to Safety',
    sv: 'Titta: Introduktion till säkerhet',
  },
  back: {
    fi: 'Takaisin kurssi yleisnäkymään',
    en: 'Back to course overview',
    sv: 'Tillbaka till kursöversikten',
  },
};

const YOUTUBE_ID = 'xryBib7R4FU';

export const PartOneSlides = () => {
  const progress = useProgress();
  const lang = (['en', 'fi', 'sv'].includes(progress.language) ? progress.language : 'fi') as
    | 'en'
    | 'fi'
    | 'sv';
  const history = useHistory();
  const latestCompletedStep = Number(localStorage.getItem('latestCompletedStep'));
  const currentPoints = Number(localStorage.getItem('points'));
  const partOneBadge = localStorage.getItem('partOneDone');

  return (
    <div className="flex flex-col min-h-screen justify-evenly p-16">
      <Box className="my-4">
        <h2 className="text-xl font-bold mb-2">{t.slide1_title[lang]}</h2>
        <p>{t.slide1_content[lang]}</p>
      </Box>
      <Box className="my-4">
        <h2 className="text-xl font-bold mb-2">{t.slide2_title[lang]}</h2>
        <p>{t.slide2_content[lang]}</p>
      </Box>
      <Box className="my-4">
        <h2 className="text-xl font-bold mb-2">{t.slide3_title[lang]}</h2>
        <p>{t.slide3_content[lang]}</p>
      </Box>
      <Box className="my-4" itemsCenter={false}>
        <h2 className="text-xl font-bold mb-2">{t.video_title[lang]}</h2>
        <div className="aspect-w-16 aspect-h-9">
          <iframe
            src={`https://www.youtube.com/embed/${YOUTUBE_ID}`}
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="w-full rounded-lg  "
            style={{ minHeight: '500px' }}
          ></iframe>
        </div>
      </Box>
      <Button
        gradient={false}
        className=" my-4 bg-gradient-to-r from-green-600 to-green-500 \
        hover:from-green-700 hover:to-green-600 w-1/4 flex-col self-end"
        onClick={() => {
          if (currentPoints != 40 && !partOneBadge) {
            localStorage.setItem('points', String(currentPoints + 10));
            localStorage.setItem('partOneDone', 'true');
          }
          if (latestCompletedStep == 0) {
            localStorage.setItem('latestCompletedStep', '1');
          }
          history.push('/crash-course');
        }}
      >
        {t.back[lang]}
      </Button>
    </div>
  );
};
